import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import BorderHeading from "../../../components/heading/BorderHeading";
import { DataGrid, GridColDef, GridColumnHeaderParams, GridValueGetterParams } from "@mui/x-data-grid";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField, Tooltip } from "@mui/material";
import { navigateType, viewOrderRowsData, popupType, userDetailsRowsData, navigateApprovalType, extendedAttributesType } from "../../../types/types";
import {
  getAllOrderDetailsData,
  updateApproval,
  updateOrderStatus,
} from "../../../services/manageOrderService";
import { useLocation, useNavigate} from "react-router-dom";
import { userDetailsConfig } from "./userDetailsConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import "../../../features/manageBasket/ManageBasket.css";
import "./userDetails.css";
import { Loader } from "../../../components/loader/Loader";
import { ConfirmationPopUp } from "../../../components/popup/confirmationPopUp";
import { GenericPopUp } from "../../../components/popup/genericPopUp";
import { useAuth } from "../../../providers/AuthProvider";
import { getUserDetailsById } from "../../../services/adminValidationService";


const UserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state: navigateApprovalType = location.state as navigateApprovalType;

  const [rows, setRows] = useState<userDetailsRowsData[]>([]);
  const [loader, setLoader] = useState(false);
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [status,setStatus] = useState(state.row.status);
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [error, setError] = useState(false);
  const [extendedAttributes, setExtendedAttributes] = useState<extendedAttributesType>({
    loginId: "",
    accountHolderName: "",
    accountNumber: "",
    ifsc: "",
    authPersonName: "",
    email: "",
    mobile: "",
    contactName: "",
    pan: "",
    gstin: "",
    checkLeafURL: "",
    addressLine1: "",
    addressLine2: "",
    constitution: "",
    bankName: "",
    pincode:"",
    authorizationLetter: "",
    extraAttributes: ""
}
);
const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    setError(false)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event:any) => {
    setComment(event.target.value);
    if (event.target.value.trim() !== "") {
      setError(false); 
  }
  };

  const popUpSuccessMethod = useRef<any>();

  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const updateConfirmationPopData = (
    message: string,
    methodHelper: () => void
  ) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  const extendedAttributesBody = {
    "rejectionComment": comment
}

  const handleReject = async () => {
    if (comment.trim() === "") {
      setError(true);
      return;
  }
  setOpen(false);
    let requestBody = {
      loginId: state.row.referenceId,
      status: "REJECTED",
      extendedAttributes: extendedAttributesBody
    };
    const response = await updateApproval(
      requestBody
    );
    if(response.data.status === "Success") {
      setStatus("REJECTED");
      navigate(-1);
    }
  };

  const handleConfirm = async () => {
    
    let requestBody = {
        loginId: state.row.referenceId,
        status: "APPROVED",
        extendedAttributes: extendedAttributesBody
    };
    const response = await updateApproval(
      requestBody
    );
    if(response.data.status === "Success") {
      setStatus("APPROVED")
      navigate(-1);
    }
    
  };

  const downloadFile = (blobUrl: string) => {
    const link = document.createElement('a');
    link.href = blobUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns: GridColDef[] = userDetailsConfig.columns.map(
    (columnsMetaData) => {
      return {
        disableColumnMenu: true,
        field: columnsMetaData.mappedValue,
        headerName: columnsMetaData.headerName,
        sortable: false,
        minWidth: 100,
        flex: 1,
        headerAlign: "left",
        align: "left",
        renderCell: (params: GridValueGetterParams) => {
          if (columnsMetaData.mappedValue === "checkLeafURL" || columnsMetaData.mappedValue === "authorizationLetter") {
            return (
              <Button variant="outlined"
              sx={{ height: "3vh", backgroundColor: "#f3fcfb" }} onClick={() => downloadFile(params.row[columnsMetaData.mappedValue])}>
                {columnsMetaData.mappedValue === "checkLeafURL" ? "View Cheque" : "View Authorization Letter"}
              </Button>
            );
          } else {
            return params.value;
          }
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <Tooltip title={columnsMetaData.headerName}>
            <b>{columnsMetaData.headerName}</b>
          </Tooltip>
        ),
      } as GridColDef;
    }
  );

  const getAllOrderDetailsDataMethod = async () => {
    try {
      const response = await getUserDetailsById(state.row.id);
      if (response.data.features.length > 0) {
        let responseArray: userDetailsRowsData[] = [];
        const obj = response.data.features[0].extendedAttributes;
         const newObj : any = {};
        newObj["id"] = response.data.features[0].id;
            newObj["checkLeafURL"] = obj["blobCheckLeafURL"];
            newObj["authorizationLetter"] = obj["blobAuthorizationLetter"];
          responseArray.push(newObj);
        setExtendedAttributes(response.data.features[0].extendedAttributes);
        setRows([newObj]);
        setLoader(false);
      } else {
        throw new Error();
      }
    } catch (error) {
      setRows([]);
      openPopup("Something went wrong", "Error");
      setLoader(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    getAllOrderDetailsDataMethod();
  }, []);

  

  return (
    <>
    <ConfirmationPopUp
          openConfirmModal={confirmationPopUp}
          message={popUpMessage}
          setOpenConfirmModal={() => {
            setConfirmationPopUp(false);
          }}
          successMethod={popUpSuccessMethod.current}
        />
        <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      <div className="view-order-parent">
        <div className="summary-info-container">
          <div className="order-summary">
            <div className="order-info-tile">
              <div className="icon-and-heading">
                <FontAwesomeIcon
                  icon={faFileLines}
                  size="lg"
                  style={{ color: "#237c9d" }}
                />
                <h3>Basic Information</h3>
              </div>
              <Divider variant="middle" />
              <div className="order-summary-table">
                <table className="manage-order-summary-table">
                  <tbody>
                    <td>
                      <tr className="heading-column">Name of account holder</tr>
                      <tr className="heading-column">Bank Name</tr>
                      <tr className="heading-column">Bank account number</tr>
                      <tr className="heading-column">IFSC code</tr>
                      <tr className="heading-column">Pin code</tr>
                    </td>
                    <td>
                      <tr>{extendedAttributes.accountHolderName}</tr>
                      <tr>{extendedAttributes.bankName}</tr>
                      <tr>{extendedAttributes.accountNumber}</tr>
                      <tr>{extendedAttributes.ifsc}</tr>
                      <tr>{extendedAttributes.pincode}</tr>
                    </td>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="retailer-info">
            <div className="order-info-tile">
              <div className="icon-and-heading">
                <FontAwesomeIcon
                  icon={faFileLines}
                  size="lg"
                  style={{ color: "#237c9d" }}
                />
                <h3>Other Information</h3>
              </div>
              <Divider variant="middle" />
              <div className="order-summary-table">
                <table className="manage-order-summary-table">
                  <tbody>
                    <td>
                    <tr className="heading-column">WD constitution</tr>
                      <tr className="heading-column">WD pan</tr>
                      <tr className="heading-column">WD gst</tr>
                    </td>
                    <td>
                      <tr>{extendedAttributes.constitution}</tr>
                      <tr>{extendedAttributes.pan}</tr>
                      <tr>{extendedAttributes.gstin}</tr>
                    </td>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="order-details">
          <BorderHeading>User Details</BorderHeading>
          {loader ? (
        <Loader />
      ) : (
      <div className="view-order-table">
            <DataGrid
              disableRowSelectionOnClick={true}
              sx={{
                "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                  outline: "none !important",
                  height: "auto",
                },
              }}
              rows={rows}
              columns={columns}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "asc" }],
                },
              }}
            />
          </div>
          )}
        </div>
        
      </div>
      <div>
      {status === "PENDING" && <div className="reject-and-confirm-button-manage-order">
        <Button
          variant="contained"
          sx={{ backgroundColor: "#237C9D", height: "5vh" }}
          onClick={handleOpen}
        >
          Decline
        </Button>
        <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Rejection Reason</DialogTitle>
        <DialogContent>
          <TextField
            id="outlined-multiline-static"
            multiline
            rows={4}
            variant="outlined"
            value={comment}
            onChange={handleChange}
            required
                error={error}
                helperText={error ? "Comment is required" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
          <Button onClick={handleReject} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#237C9D", height: "5vh" }}
          onClick={() => {
            setConfirmationPopUp(true);
            updateConfirmationPopData(
              "Are you sure you want to approve the request",
              () => {
                handleConfirm()
              }
            );
          }}
        >
          Approve
        </Button>
      </div>}
      </div>
    </>
  );
};

export default UserDetails;
